import BodyScroll from "./components/body-scroll";
import HeroVideo from "./components/hero-video";
import ReadMoreToggler from "./components/read-more-toggler";
import PhotoSwipeTheme from "./components/photoswipe";
import Datepicker from "./components/datepicker";
import MasonryGallery from "./components/masonry-gallery";
import JobSelector from "./components/job-selector";
import ScrollAnimations from "./components/scrollAnimations";
import Tab from "./components/tabs";
import ScrollToTop from "./components/scroll-to-top";
import MainMenu from "./components/main-menu";
import googleMap from "./components/google-maps";

function MultiselectDropdown(options) {
	var config = {
		height: "9rem",
		placeholder: "select",
		txtSelected: "selected",
		txtAll: "All",
		txtRemove: "Remove",
		...options,
	};

	function newEl(tag, attrs) {
		var e = document.createElement(tag);
		if (attrs !== undefined)
			Object.keys(attrs).forEach((k) => {
				if (k === "class") {
					Array.isArray(attrs[k])
						? attrs[k].forEach((o) => (o !== "" ? e.classList.add(o) : 0))
						: attrs[k] !== ""
						? e.classList.add(attrs[k])
						: 0;
				} else if (k === "style") {
					Object.keys(attrs[k]).forEach((ks) => {
						e.style[ks] = attrs[k][ks];
					});
				} else if (k === "text") {
					attrs[k] === "" ? (e.innerHTML = "&nbsp;") : (e.innerText = attrs[k]);
				} else e[k] = attrs[k];
			});
		return e;
	}

	document.querySelectorAll("select[multiple]").forEach((el, k) => {
		var div = newEl("div", {
			class: "multiselect-dropdown",
			style: {
				width: config.style?.width ?? el.clientWidth + "px",
				padding: config.style?.padding ?? "",
			},
		});
		el.style.display = "none";
		el.parentNode.insertBefore(div, el.nextSibling);
		var listWrap = newEl("div", {
			class: "multiselect-dropdown-list-wrapper",
		});
		var list = newEl("div", {
			class: "multiselect-dropdown-list",
			style: { height: config.height },
		});

		div.appendChild(listWrap);

		listWrap.appendChild(list);

		el.loadOptions = () => {
			list.innerHTML = "";

			if (el.attributes["multiselect-select-all"]?.value == "true") {
				var op = newEl("div", {
					class: "multiselect-dropdown-all-selector",
				});
				var ic = newEl("input", { type: "checkbox" });
				op.appendChild(ic);
				op.appendChild(newEl("label", { text: config.txtAll }));

				op.addEventListener("click", () => {
					op.classList.toggle("checked");
					op.querySelector("input").checked =
						!op.querySelector("input").checked;

					var ch = op.querySelector("input").checked;
					list
						.querySelectorAll(
							":scope > div:not(.multiselect-dropdown-all-selector)"
						)
						.forEach((i) => {
							if (i.style.display !== "none") {
								i.querySelector("input").checked = ch;
								i.optEl.selected = ch;
							}
						});

					el.dispatchEvent(new Event("change"));
				});
				ic.addEventListener("click", (ev) => {
					ic.checked = !ic.checked;
				});
				el.addEventListener("change", (ev) => {
					let itms = Array.from(
						list.querySelectorAll(
							":scope > div:not(.multiselect-dropdown-all-selector)"
						)
					).filter((e) => e.style.display !== "none");
					let existsNotSelected = itms.find(
						(i) => !i.querySelector("input").checked
					);
					if (ic.checked && existsNotSelected) ic.checked = false;
					else if (ic.checked == false && existsNotSelected === undefined)
						ic.checked = true;
				});

				list.appendChild(op);
			}

			Array.from(el.options).map((o) => {
				var op = newEl("div", {
					class: o.selected ? "checked" : "",
					optEl: o,
				});
				var ic = newEl("input", { type: "checkbox", checked: o.selected });
				op.appendChild(ic);
				op.appendChild(newEl("label", { text: o.text }));

				op.addEventListener("click", () => {
					op.classList.toggle("checked");
					op.querySelector("input").checked =
						!op.querySelector("input").checked;
					op.optEl.selected = !!!op.optEl.selected;
					el.dispatchEvent(new Event("change"));
				});
				ic.addEventListener("click", (ev) => {
					ic.checked = !ic.checked;
				});
				o.listitemEl = op;
				list.appendChild(op);
			});
			div.listEl = listWrap;

			div.refresh = () => {
				div
					.querySelectorAll("span.optext, span.placeholder")
					.forEach((t) => div.removeChild(t));

				var sels = Array.from(el.selectedOptions);
				sels.map((x) => {
					var c = newEl("span", {
						class: "optext",
						text: x.text,
						srcOption: x,
					});

					c.appendChild(
						newEl("span", {
							class: "optdel",
							innerHTML:
								'<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 1rem; height: 1rem;"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>',
							title: config.txtRemove,
							onclick: (ev) => {
								c.srcOption.listitemEl.dispatchEvent(new Event("click"));
								div.refresh();
								ev.stopPropagation();
							},
						})
					);

					div.appendChild(c);
				});

				if (0 == el.selectedOptions.length) {
					div.appendChild(
						newEl("span", {
							class: "placeholder",
							text: el.attributes["placeholder"]?.value ?? config.placeholder,
						})
					);
				}
			};
			div.refresh();
		};
		el.loadOptions();

		div.addEventListener("click", () => {
			div.listEl.style.display = "block";
		});

		document.addEventListener("click", function (event) {
			if (!div.contains(event.target)) {
				listWrap.style.display = "none";
				div.refresh();
			}
		});
	});
}

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== "loading") {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener("DOMContentLoaded", onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent("onreadystatechange", function () {
			if (document.readyState === "complete") {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {
		window.addEventListener("resize", () => {
			let vh = window.innerHeight * 0.01;
			document.querySelectorAll(".vh").forEach(function (el) {
				el.style.setProperty("--vh", vh + "px");
			});
		});

		const heroVideo = new HeroVideo();
		const bodyScroll = new BodyScroll();

		// Read more toggle
		Array.from(document.querySelectorAll("a.read-more")).map(
			(el) => new ReadMoreToggler(el)
		);

		// Photoswipe
		Array.from(document.querySelectorAll(".masonry-gallery")).map(
			(el) => new PhotoSwipeTheme(el)
		);

		Array.from(document.querySelectorAll(".gallery-slideshow")).map(
			(el) => new PhotoSwipeTheme(el)
		);

		// Air DatePicker
		Array.from(document.querySelectorAll(".datepicker")).map(
			(el) => new Datepicker(el)
		);

		// Custom Flickity Slider
		const customSlider = document.querySelector(".custom-slider");
		if (customSlider) {
			const totalSliders = customSlider.querySelectorAll("article").length;
			customSlider.style.setProperty("--total-slides", totalSliders);

			if ("function" === typeof Flickity) {
				let flTO = setInterval(() => {
					let flickity = Flickity.data(customSlider);
					if (flickity) {
						clearInterval(flTO);
						customSlider.querySelector(".counter .total").textContent =
							totalSliders.toString();
						flickity.on("change", function (index) {
							customSlider.querySelector(".counter .current").textContent =
								index + 1;
						});
					}
				}, 100);
			}
		}

		// Flickity Mega Slider
		const megaSlider = document.querySelector(".mega-slider");
		if (megaSlider) {
			const totalSliders = megaSlider.querySelectorAll("article").length;
			megaSlider.style.setProperty("--total-slides", totalSliders);

			if ("function" === typeof Flickity) {
				let flTO = setInterval(() => {
					let flickity = Flickity.data(megaSlider);
					if (flickity) {
						clearInterval(flTO);
						megaSlider.querySelector(".counter .total").textContent =
							totalSliders.toString();
						flickity.on("change", function (index) {
							megaSlider.querySelector(".counter .current").textContent =
								index + 1;
						});
						const navButtons = megaSlider.querySelector(".navigation-buttons");
						if (navButtons) {
							navButtons
								.querySelector(".prev")
								.addEventListener("click", (ev) => {
									flickity.previous();
								});
							navButtons
								.querySelector(".next")
								.addEventListener("click", (ev) => {
									flickity.next();
								});
						}
					}
				}, 100);
			}
		}

		// Masonry Gallery
		Array.from(document.querySelectorAll(".masonry-gallery")).map(
			(el) => new MasonryGallery(el)
		);

		// Jobs Selector
		Array.from(document.querySelectorAll(".js-job-selector")).map(
			(el) => new JobSelector(el)
		);

		// Scroll Animations
		Array.from(document.querySelectorAll("[data-smooth-scroll]")).map(
			(el) => new ScrollAnimations(el)
		);

		// 360 Virtual Tours
		Array.from(
			document.querySelectorAll(
				'.js-has-flickity-tab-content[data-bs-toggle="tab"]'
			)
		).map((el) => new Tab(el));

		// Modals for 360 virtual tours
		Array.from(document.querySelectorAll('a[data-bs-toggle="modal"]')).map(
			(el) => {
				el.addEventListener("click", (ev) => ev.preventDefault());
			}
		);

		window.addEventListener("load", () => {
			MultiselectDropdown(window.MultiselectDropdownOptions);
		});

		// Bootstrap event when main menu opens
		// https://getbootstrap.com/docs/5.3/components/offcanvas/#via-javascript
		//
		// const myOffcanvas = document.getElementById("navbarNavOffcanvas");
		// myOffcanvas.addEventListener("show.bs.offcanvas", (event) => {
		// 	console.log("show.bs.offcanvas");
		// });

		// Observer for fade-in-me effect
		let observerOptions = {
			// threshold: [0, 1]
		};

		const observerEffectFade = new IntersectionObserver((entries) => {
			entries.map((entry, index) => {
				if (entry.isIntersecting) {
					setTimeout(() => {
						entry.target.classList.add("is-in-view");
						observerEffectFade.unobserve(entry.target);
					}, 50 * index);
				}
			});
		}, observerOptions);
		document
			.querySelectorAll(".fade-in-me")
			.forEach((observable) => observerEffectFade.observe(observable));

		const scroll = new ScrollToTop();

		const mainMenu = new MainMenu();

		Array.from(document.querySelectorAll('.map')).map(el => googleMap(el, el.dataset.json));

		setTimeout(() => {
			window.dispatchEvent(new Event("resize"));
		}, 1000);
	},
};

domLoaded(() => {
	App.init();
});
